import NewPartnerLandingForm from './NewPartnerLandingForm';
export default NewPartnerLandingForm;
export * from './NewPartnerLandingForm';
